module.exports = __webpack_public_path__ + "img/YAPITRISFEX.7d699bed.png";